import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=c9cc6a8a&scoped=true&"
import script from "./Testimonial.vue?vue&type=script&lang=js&"
export * from "./Testimonial.vue?vue&type=script&lang=js&"
import style0 from "./Testimonial.vue?vue&type=style&index=0&id=c9cc6a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cc6a8a",
  null
  
)

export default component.exports